import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Storage } from './lib/storage'

// Bloque de Inicialización de Alta Disponibilidad
async function initApp() {
  await Storage.init();
  
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

initApp();
